import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowWall2Up: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowWall2Up"><Path fillRule="evenodd" clipRule="evenodd" d="M4 3H20V5H12.4142L17.6642 10.25L16.25 11.6642L13 8.41421V21H11V8.41422L7.75 11.6642L6.33579 10.25L11.5858 5H4V3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowWall2Up;
